module.exports = __webpack_public_path__ + "static/media/dance.6b840a6d.png";